import { NavLink } from "react-router"
import React from "react"
import Layout from "../components/layout"

export function NotFound()
{
  return (
    <Layout>
      <section className="section-boxes section-boxes--secondary p-4">
        <div className="shell">
          <h1>Oh dear, the page you have requested is not available</h1>
          <p>
            Please navigate to the <NavLink to="/">home page.</NavLink>
          </p>
        </div>
      </section>
    </Layout>
  )
}
